<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
	[showBreadcrumb]="true"
	[breadcrumb]="breadcrumb()"
	[useDynamicBack]="true"
></lvr-nav-carousel>

@let doc = document();
<div class="header">
	<h2>{{ doc.name }}</h2>
	<div class="actions-row">
		<!-- Download -->
		<lvr-button
			variant="primary"
			[label]="'base.button.download' | transloco"
			[loading]="isDownloading()"
			[loadingLabel]="'base.button.download' | transloco"
			[type]="'button'"
			(clicked)="download()"
			icon="download"
		>
		</lvr-button>

		<!-- Delete -->
		<div [matTooltip]="getDeleteTooltip() | transloco">
			<lvr-button
				variant="primary"
				[label]="'base.button.delete' | transloco"
				[type]="'button'"
				[disabled]="!canDeleteDocument()"
				(clicked)="deleteClicked.emit()"
				icon="delete"
			>
			</lvr-button>
		</div>
	</div>
</div>

<!-- Document view -->
<div class="wrap">
	@if (isPdf() && safeUrl()) {
		<iframe class="doc-frame" [src]="safeUrl()" width="100%" height="100%"></iframe>
	}

	@if (isImage()) {
		<img class="doc-frame" [src]="doc.location" [alt]="doc.name" />
	}

	<!-- No preview -->
	@if (!canPreview()) {
		<div class="no-preview">
			<p>
				{{ 'client.documents.no_preview' | transloco }}
			</p>
		</div>
	}
</div>
